/* eslint-disable no-unused-vars */
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Separator from 'components/common/Separator.js';
import SectionLayout from 'components/common/SectionLayout';
import * as S from './CustomAudience.styled';
import ChooseAudienceBtn from './chooseAudienceBtn/ChooseAudienceBtn';
import { selected_custom_audience, select_custom_audience_target_type } from 'store/selectors';
import { generalActions } from 'store/actions';
import { ParagraphWithTooltip, Label, RadioBox, IconButton } from 'components';
import { RadioBoxGroup, RightSideContainer } from '../components';
import { DeleteIcon } from 'assets/icons';

export default function TargetingOngoingCustomAudience() {
  const selectedAudience = useSelector(selected_custom_audience);

  const targetType = useSelector(select_custom_audience_target_type);
  const dispatch = useDispatch();
  const handleDelete = () => {
    dispatch(
      generalActions.updateCurrentCampaignObj({
        propField: 'customAudienceObj',
        newValue: '',
      }),
    );
    dispatch(
      generalActions.updateCurrentCampaignObj({
        propField: 'customAudienceGoal',
        newValue: false,
      }),
    );
  };

  const handleChangeType = useCallback(
    (newValue) => {
      if (newValue === targetType) return;
      dispatch(
        generalActions.updateCurrentCampaignObj({
          propField: 'customAudience_IsInclude',
          newValue: newValue,
        }),
      );
    },
    [targetType],
  );

  return (
    <>
      <SectionLayout
        leftSide={
          <>
            <Label text='Custom Audience:' variant='label' />
            <Label variant='description' text='Optional' />
          </>
        }
        rightSide={
          <RightSideContainer>
            <RadioBoxGroup>
              <RadioBox.NormalSize
                onChange={handleChangeType}
                label='Target'
                width={88}
                variant='left'
                value={true}
                pressed={targetType === true}
              />
              <RadioBox.NormalSize
                onChange={handleChangeType}
                label='Exclude'
                width={97}
                variant='right'
                value={false}
                pressed={targetType === false}
              />
            </RadioBoxGroup>
            <S.ManageAudience>
              <S.Container>
                <ChooseAudienceBtn />
                <S.ManageAudienceMessage>
                  <S.Info>
                    <S.FlexRow1>
                      <S.MessageInfo>
                        <S.InfoText>i</S.InfoText>
                      </S.MessageInfo>
                      <S.MessageText>
                        In order to connect and receive audience lists from 3rd party source, please
                        go to <br />
                        Advanced Settings → 3rd Party Audience
                      </S.MessageText>
                    </S.FlexRow1>
                  </S.Info>
                </S.ManageAudienceMessage>
              </S.Container>
              {selectedAudience?.custAudNumber ? (
                <>
                  <Separator />
                  <S.Label>{targetType ? 'Target:' : 'Exclude:'}</S.Label>
                  <S.Container color='#F1F5F9'>
                    <S.SelectedItems>
                      <S.SelectedItem>
                        <S.ItemName>
                          <ParagraphWithTooltip text={selectedAudience.audienceName} />
                        </S.ItemName>
                        {selectedAudience?.is_file_in_loading_process ? (
                          <S.Text>processing...</S.Text>
                        ) : (
                          selectedAudience?.partnerName && (
                            <>
                              <S.Text>uploaded via</S.Text>
                              <S.PartnerIcon
                                src={`https://file.rendit.io/n/MoJJuaPTUuns9uZbe3LF.svg`}
                              />
                            </>
                          )
                        )}
                      </S.SelectedItem>
                      <IconButton.SmallSize
                        isDefaultMuted
                        icon={DeleteIcon}
                        type={IconButton.btnTypes.tertiary}
                        onClick={handleDelete}
                      />
                    </S.SelectedItems>
                    {selectedAudience?.fileAnalyzeMessage && (
                      <Label
                        style={{ marginTop: '10px' }}
                        text={selectedAudience?.fileAnalyzeMessage}
                        variant='warningDesc'
                      />
                    )}
                  </S.Container>
                </>
              ) : null}
            </S.ManageAudience>
          </RightSideContainer>
        }
      />
    </>
  );
}
